export const ABOUT_DESCRIPTION_BG =
  "Perceptica развива медийния мониторинг, MLP платформата и експертния медиен анализ като една свързана система за решения в Югоизточна Европа.";
